import { NumberRange } from "../../model/type";

const formatFootfall = (object: { footfall?: number | null, footfallRange?: NumberRange | null }): string => {
    if (!object.footfall && !object.footfallRange) {
        return '';
    }

    if (object.footfall) {
        return object.footfall.toString();
    }

    if (!object.footfallRange?.max) {
        return '> ' + object.footfallRange?.min;
    }

    if (!object.footfallRange?.min) {
        return '< ' + object.footfallRange?.max;
    }

    return object.footfallRange.min + ' - ' + object.footfallRange.max;
}
export default formatFootfall;